import { create } from 'zustand';

/**
 * A zustand store specifically for persisting the horizontal position of the grid.
 * This is purely a user interaction state, it shouldn't be part of GRID_STATE.
 */
export const useScrollLeftStore = create<{
  record: { [resultSetId: string]: number };
  setScrollLeft: (resultSetId: string, scrollLeft: number) => void;
}>((set) => ({
  record: {},
  setScrollLeft: (resultSetId: string, scrollLeft: number) =>
    set(({ record }) => ({
      record: { ...record, [resultSetId]: scrollLeft }
    }))
}));
